import { render, staticRenderFns } from "./authentice-form.vue?vue&type=template&id=6f5a1474&scoped=true"
import script from "./authentice-form.vue?vue&type=script&lang=js"
export * from "./authentice-form.vue?vue&type=script&lang=js"
import style0 from "./authentice-form.vue?vue&type=style&index=0&id=6f5a1474&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a1474",
  null
  
)

export default component.exports